/* eslint-disable import/no-anonymous-default-export */
import React, { useState } from 'react'
import { useTranslation } from '@sailor/i18n-web'
import { Breadcrumb } from '@roo/roo'
import { useNavigate } from 'react-router-dom'
import PageTabs from '@/components/PageTabs'
import { getHashQuery } from '@/common/utils'
import BalanceListTab from './components/BalanceListTab'
import TransactionDetailTab from './components/TransactionDetailTab'
import styles from './index.module.less'

const { Pane: TabPane } = PageTabs

type TabKey = 'balance' | 'transactions'

export default () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const query = getHashQuery<{ periodType?: string; budgetPolicyNo?: string; rulePackageId?: string }>()

  /**
   * periodType：下发周期类型，0=一次性下发，1=循环下发
   * 一次性下发（periodType=0）才显示余额调整、批量调整功能
   * budgetPolicyNo：津贴策略编号，用于接口查询
   */
  const periodType = Number(query.periodType ?? 0)
  const isOnceType = periodType === 0
  const budgetPolicyNo = decodeURIComponent(query.budgetPolicyNo || '')
  const rulePackageId = query.rulePackageId || ''
  const [activeTab, setActiveTab] = useState<TabKey>('balance')
  const [defaultKeyword, setDefaultKeyword] = useState<string | undefined>(undefined)

  const handleViewTransactions = (keyword: string) => {
    setDefaultKeyword(keyword || undefined)
    setActiveTab('transactions')
  }

  const handleTabClick = (name: string) => {
    setActiveTab(name as TabKey)
    if (name === 'balance') {
      setDefaultKeyword(undefined)
    }
  }

  const breadcrumbItems = [
    {
      text: t('e_pc_rule_management', '规则管理'),
      icon: 'home',
      onClick: () => navigate('/rule'),
    },
    {
      text: t('e_pc_balance_mgmt', '余额管理'),
    },
  ]

  return (
    <div className={`page-content ${styles.balance_page}`} style={{ display: 'flex', flexDirection: 'column' }}>
      <div className={styles.breadcrumb_wrap}>
        <Breadcrumb items={breadcrumbItems} style={{ marginBottom: 0 }} />
      </div>

      <PageTabs
        value={activeTab}
        onTabClick={handleTabClick}
      >
        <TabPane label={t('e_pc_balance_mgmt', '余额管理')} name="balance" />
        <TabPane label={t('e_pc_change_details', '变动明细')} name="transactions" />
      </PageTabs>

      <div style={{ marginTop: 16, display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
        {activeTab === 'balance' && (
          <BalanceListTab
            budgetPolicyNo={budgetPolicyNo}
            periodType={periodType}
            isOnceType={isOnceType}
            rulePackageId={rulePackageId}
            onViewTransactions={handleViewTransactions}
          />
        )}

        {activeTab === 'transactions' && (
          <TransactionDetailTab
            budgetPolicyNo={budgetPolicyNo}
            defaultKeyword={defaultKeyword}
          />
        )}
      </div>
    </div>
  )
}
